import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }
  reset = () => this.setState({ hasError: false, error: null });
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="rounded-2xl border border-destructive/30 bg-destructive/5 p-6 space-y-3">
          <div className="flex items-center gap-2 text-destructive font-display">
            <AlertTriangle className="w-5 h-5" /> Bu bölümde bir sorun oluştu
          </div>
          <p className="text-sm text-muted-foreground">
            Sayfanın geri kalanı çalışmaya devam ediyor. Aşağıdaki butona tıklayarak bu bölümü yeniden yükleyebilirsiniz.
          </p>
          <details className="text-xs text-muted-foreground">
            <summary className="cursor-pointer">Teknik detay</summary>
            <pre className="mt-2 whitespace-pre-wrap break-all">{String(this.state.error?.message || this.state.error)}</pre>
          </details>
          <Button size="sm" variant="outline" onClick={this.reset}>
            <RefreshCw className="w-3 h-3 mr-2" /> Tekrar dene
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
